import { BaseJWTService } from "@/services/base";

export class AlfredService extends BaseJWTService {
  constructor({ apiUrl }) {
    super({ apiUrl });
  }

  async login(payload) {
    const response = await this.api.post("/accounts/login", payload);
    return response.data;
  }

  async domainCheck(payload) {
    const response = await this.api.post("/accounts/domain-check", payload);
    return response.data;
  }

  async refreshToken(payload) {
    const response = await this.api.post("/accounts/refresh", payload);
    return response.data;
  }

  async getUser() {
    const response = await this.api.get("/accounts/user");
    return response.data;
  }

  async fetchUserBalance() {
    const response = await this.api.get("/credits-check");
    return response.data;
  }

  async updateUser(payload) {
    const response = await this.api.patch("/accounts/user", payload);
    return response.data;
  }

  async getUsers(urlParams) {
    let url = "/accounts/users";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async adminGetUser(id) {
    const response = await this.api.get(`/accounts/users/${id}`);
    return response.data;
  }

  async addUserCreditsBalance(payload) {
    const response = await this.api.patch(
      "/admin/add-user-credits-balance",
      payload
    );
    return response.data;
  }

  async adminUserCreditsBalance(user_id) {
    const response = await this.api.get(
      `/admin/credits-balance?user_id=${user_id}`
    );
    return response.data;
  }

  async syncUserCredits(payload) {
    const response = await this.api.post("/admin/credits-sync", payload);
    return response.data;
  }

  async adminCreditDrift(limit = 100) {
    const response = await this.api.get(`/admin/credits-drift?limit=${limit}`);
    return response.data;
  }

  async deductUserCreditsBalance(payload) {
    const response = await this.api.post("/admin/user-credit-deduct", payload);
    return response.data;
  }

  async updateSubUserCredits(payload) {
    const response = await this.api.patch("/accounts/subuser-credits", payload);
    return response.data;
  }
  async partnerSettingsCreate(payload) {
    const response = await this.api.post("/admin/partner-setting", payload);
    return response.data;
  }

  async partnerSettingsGet(user) {
    const response = await this.api.get(
      `/admin/partner-setting/partner?user=${user}`
    );
    return response.data;
  }

  async partnerSettingsDelete(user) {
    const response = await this.api.delete(
      `/admin/partner-setting?user=${user}`
    );
    return response.data;
  }

  async partnerSettingsRegGet(partner_code) {
    const response = await this.api.get(
      `/admin/partner-setting?partner_code=${partner_code}`
    );
    return response.data;
  }

  async linkedAccountList(user_id, search) {
    let url = `/admin/linked-accounts?user_id=${user_id}`;
    if (search) {
      url = `${url}&search=${search}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async add_user(payload) {
    const response = await this.api.post("/accounts/user-create", payload);
    return response.data;
  }

  async get_user(payload) {
    const response = await this.api.get("/accounts/user-create", payload);
    return response.data;
  }
  async reactivate_user(payload) {
    const response = await this.api.patch("/accounts/user-create", {
      email: payload,
    });
    return response.data;
  }

  async delete_user(email) {
    const response = await this.api.delete(
      `/accounts/user-create?email=${email}`
    );
    return response.data;
  }

  async register(payload) {
    const response = await this.api.post("/accounts/create", payload);
    return response.data;
  }

  async verifyEmail(payload) {
    const response = await this.api.post("/accounts/verify-email", payload);
    return response.data;
  }

  async resetPassword(payload) {
    const response = await this.api.post(
      "/accounts/reset-password/initiate",
      payload
    );
    return response.data;
  }

  async confirmResetPassword(payload) {
    const response = await this.api.post(
      "/accounts/reset-password/verify",
      payload
    );
    return response.data;
  }

  async uploadFile(payload) {
    const response = await this.api.post("/upload", payload);
    return response.data;
  }

  async realtimeEmailCheck(payload) {
    const response = await this.api.post("/email-check", payload);
    return response.data;
  }

  async realtimeEmailDashboard(urlParams) {
    let url = "/email-check/dashboard";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async realtimeEmailSummary(id) {
    let url = `/email-check/${id}/summary_combined`;
    const response = await this.api.get(url);
    return response.data;
  }

  async realtimeEmailPreview(id, urlParams) {
    let url = `/email-check/${id}/preview`;
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async UserStats(payload) {
    let url = "/admin/statistics";
    const response = await this.api.post(url, payload);
    return response.data;
  }

  async UserStatsTopUser(payload) {
    let url = "/admin/statistics/top-users";
    const response = await this.api.post(url, payload);
    return response.data;
  }

  async DomainControlAdd(payload) {
    let url = "/admin/domain-control";
    const response = await this.api.post(url, payload);
    return response.data;
  }

  async DomainControlGet(urlParams) {
    let url = "/admin/domain-control";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async DomainControlEdit(id, payload) {
    let url = `/admin/domain-control/${id}`;
    const response = await this.api.put(url, payload);
    return response.data;
  }

  async DomainControlDelete(id) {
    let url = `/admin/domain-control/${id}`;
    const response = await this.api.delete(url);
    return response.data;
  }

  async bannedDomainsGet(urlParams) {
    let url = "/admin/banned-domains";
    if (urlParams) {
      const params = { ...urlParams };
      if (!params.search) {
        delete params.search;
      }
      const searchParams = new URLSearchParams(params);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async bannedDomainAdd(payload) {
    let url = "/admin/banned-domains";
    const response = await this.api.post(url, payload);
    return response.data;
  }

  async bannedDomainEdit(id, payload) {
    let url = `/admin/banned-domains/${id}`;
    const response = await this.api.patch(url, payload);
    return response.data;
  }

  async bannedDomainDelete(id) {
    let url = `/admin/banned-domains/${id}`;
    const response = await this.api.delete(url);
    return response.data;
  }

  async bannedDomainsImportStart(formData) {
    let url = "/admin/banned-domain-imports";
    const response = await this.api.post(url, formData);
    return response.data;
  }

  async bannedDomainsImportGet(id) {
    let url = `/admin/banned-domain-imports/${id}`;
    const response = await this.api.get(url);
    return response.data;
  }

  async bannedDomainsImportsList(urlParams) {
    let url = "/admin/banned-domain-imports";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async RecurringPaymentAdd(payload) {
    let url = "/recurring-payment";
    const response = await this.api.post(url, payload);
    return response.data;
  }

  async RecurringPaymentGet() {
    let url = "/recurring-payment";
    const response = await this.api.get(url);
    return response.data;
  }

  async RecurringPaymentEdit(payload) {
    let url = `/recurring-payment`;
    const response = await this.api.patch(url, payload);
    return response.data;
  }

  async RecurringPaymentDelete() {
    let url = `/recurring-payment`;
    const response = await this.api.delete(url);
    return response.data;
  }

  async AdminRecurringPaymentAdd(payload) {
    let url = "admin/recurring-payment";
    const response = await this.api.post(url, payload);
    return response.data;
  }

  async AdminRecurringPaymentGet(userId, user_recurring = false) {
    let url = `admin/recurring-payment?user=${userId}`;
    if (user_recurring) {
      url += `&user_recurring=true`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async AdminRecurringPaymentEdit(userId, payload) {
    let url = `admin/recurring-payment?user=${userId}`;
    const response = await this.api.patch(url, payload);
    return response.data;
  }

  async AdminRecurringPaymentDelete(userId) {
    let url = `admin/recurring-payment?user=${userId}`;
    const response = await this.api.delete(url);
    return response.data;
  }

  async StatsNewUsers(urlParams) {
    let url = "/admin/user-activity";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async StatsCreditPurchase(urlParams) {
    let url = "/admin/credit-purchase";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async UserCreditPurchase(urlParams) {
    let url = "/admin/user-credit-purchases";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async AdminTransactions(urlParams) {
    let url = "/admin/transactions";
    if (urlParams) {
      const cleanParams = Object.fromEntries(
        Object.entries(urlParams).filter(([, value]) => value !== "" && value != null)
      );
      const searchParams = new URLSearchParams(cleanParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async StatsCreditChurnUsers(urlParams) {
    let url = "/admin/churn-user";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async StatsChurnUsersActivity(urlParams) {
    let url = "/admin/churn-user/activity";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async Bouncer(urlParams) {
    let url = "/admin/bouncer";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async JobTrackerStats() {
    let url = "admin/job-tracker-time/queue-stats";
    const response = await this.api.get(url);
    return response.data;
  }

  async adminQueues() {
    const response = await this.api.get("/admin/queues");
    return response.data;
  }

  // Consumption of the queues Alfred owns. Without a name, every owned queue.
  async adminPauseQueue(name = null) {
    const url = name
      ? `/admin/queues/${encodeURIComponent(name)}/pause`
      : "/admin/queues/pause";
    const response = await this.api.post(url);
    return response.data;
  }

  async adminResumeQueue(name = null) {
    const url = name
      ? `/admin/queues/${encodeURIComponent(name)}/resume`
      : "/admin/queues/resume";
    const response = await this.api.post(url);
    return response.data;
  }

  // Producing to the queues Alfred produces to. Without a name, every one.
  async adminPauseProducing(name = null) {
    const url = name
      ? `/admin/producers/${encodeURIComponent(name)}/pause`
      : "/admin/producers/pause";
    const response = await this.api.post(url);
    return response.data;
  }

  async adminResumeProducing(name = null) {
    const url = name
      ? `/admin/producers/${encodeURIComponent(name)}/resume`
      : "/admin/producers/resume";
    const response = await this.api.post(url);
    return response.data;
  }

  async adminObliterateQueue(name) {
    const response = await this.api.delete(
      `/admin/queues/${encodeURIComponent(name)}`,
      { params: { confirm: name } }
    );
    return response.data;
  }

  async JobTrackerTime(urlParams) {
    let url = `/admin/job-tracker-time`;
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async JobTrackerImpact(urlParams) {
    let url = `/admin/job-tracker-impact`;
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async JobTrackerProcessingFiles(urlParams) {
    let url = `/admin/job-tracker-processing-jobs`;
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async getSystemStatusAdmin() {
    const response = await this.api.get("/admin/system-status");
    return response.data;
  }

  async createSystemStatus(payload) {
    const response = await this.api.post("/admin/system-status", payload);
    return response.data;
  }

  async updateSystemStatus(id, payload) {
    const response = await this.api.put(`/admin/system-status/${id}`, payload);
    return response.data;
  }

  async deleteSystemStatus(id) {
    const response = await this.api.delete(`/admin/system-status/${id}`);
    return response.data;
  }

  async fetchAdminJobs(urlParams) {
    let url = "/admin/jobs";

    if (urlParams) {
      if (urlParams.emailJob && urlParams.emailJob == "Real-time") {
        url = "/admin/email-check";
      }
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async fetchStuckAdminJobs(urlParams) {
    let url = "/admin/jobs/stuck";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async fetchAdminJobsOrgSummary(urlParams) {
    let url = "/admin/jobs/org-summary";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async retryAdminJob(jobId) {
    const response = await this.api.post(`/admin/jobs/${jobId}/retry`);
    return response.data;
  }

  async cancelAdminJob(jobId) {
    const response = await this.api.post(`/admin/jobs/${jobId}/cancel`);
    return response.data;
  }

  async fetchDashboardJobs(urlParams) {
    let url = "/jobs/dashboard";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async fetchDashboard(urlParams) {
    let url = "/dashboard";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async fetchJobs(urlParams) {
    let url = "/jobs";
    if (urlParams) {
      if (urlParams.emailJob && urlParams.emailJob == "Real-time") {
        url = "/email-check";
      }
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async fetchUserJobs(urlParams) {
    let url = "/user-job-usage";
    if (urlParams) {
      if (urlParams.emailJob && urlParams.emailJob == "Real-time") {
        url = "/user-realtime-usage";
      }
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async getJob(id) {
    const response = await this.api.get(`/jobs/${id}`);
    return response.data;
  }

  async createJob(payload) {
    const response = await this.api.post("/jobs", payload);
    return response.data;
  }

  async deleteJob(id) {
    const response = await this.api.delete(`/jobs/${id}`);
    return response.data;
  }

  async deleteUpload(id) {
    const response = await this.api.delete(`/upload/${id}`);
    return response.data;
  }

  async verifyJob(payload) {
    const response = await this.api.post("/jobs/verify", payload);
    return response.data;
  }

  shouldRefresh(config) {
    if (config.url === "/accounts/refresh") {
      return false;
    }
    return BaseJWTService.prototype.shouldRefresh.call(this, config);
  }

  async createPaymentMethod(payload) {
    const response = await this.api.post("/accounts/payment-methods", payload);
    return response.data;
  }

  async expertDownload(id, payload) {
    const response = await this.api.post(
      `/jobs/${id}/expert-download`,
      payload
    );
    return response.data;
  }

  async threatFileDownload(id, searchParams) {
    const response = await this.api.get(
      `/jobs/${id}/threat-file-download?${searchParams}`
    );
    return response.data;
  }

  async klaviyoExport(payload) {
    const response = await this.api.post("/klaviyo-export", payload);
    return response.data;
  }

  async klaviyoExportDetails(payload) {
    const response = await this.api.get(`/klaviyo-export?job_id=${payload}`);
    return response.data;
  }

  async klaviyoAPIKey() {
    const response = await this.api.get("/klaviyo-api-key");
    return response.data;
  }

  async klaviyoAPIKeyDelete() {
    const response = await this.api.delete("/klaviyo-api-key");
    return response.status;
  }

  async postKlaviyoAPIKey(payload) {
    try {
      return await this.api.post("/klaviyo-api-key", payload);
    } catch (error) {
      return error.response?.status;
    }
  }

  async klaviyoImport(payload) {
    const response = await this.api.post("/klaviyo-import", payload);
    return response.data;
  }

  async grExport(payload) {
    const response = await this.api.post("/getresponse-export", payload);
    return response.data;
  }

  async postgrAPIKey(payload) {
    try {
      return await this.api.post("/getresponse-api-key", payload);
    } catch (error) {
      return error.response?.status;
    }
  }

  async grAPIKey() {
    const response = await this.api.get("/getresponse-api-key");
    return response.data;
  }

  async grAPIKeyDelete() {
    const response = await this.api.delete("/getresponse-api-key");
    return response.status;
  }

  async yotpoGetAccessToken() {
    const response = await this.api.get("/yotpo-access-key");
    return response.data;
  }

  async yotpoGenerateAccessToken(payload) {
    const response = await this.api.post("/yotpo-access-key", payload);
    return response.data;
  }

  async yotpoGetLists(urlParams) {
    const searchParams = new URLSearchParams(urlParams);
    const response = await this.api.get(
      `/yotpo-lists?${searchParams.toString()}`
    );
    return response.data;
  }

  async yotpoGetListsMembers(payload) {
    let url = `/yotpo-lists/${payload.id}`;
    if (payload.page_info) {
      url = url + `?next_page_info=${payload.page_info}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async yotpoImport(payload) {
    const response = await this.api.post("/yotpo-import", payload);
    return response.data;
  }

  async yotpoExport(payload) {
    const response = await this.api.post("/yotpo-export", payload);
    return response.data;
  }

  async yotpoExportDetails(payload) {
    const response = await this.api.get(`/yotpo-export?job_id=${payload}`);
    return response.data;
  }

  async yotpoRemoveAccessToken() {
    const response = await this.api.delete("/yotpo-access-key");
    return response.data;
  }

  async postIterableAPIKey(payload) {
    try {
      return await this.api.post("/iterable-api-key", payload);
    } catch (error) {
      return error.response?.status;
    }
  }

  async getIterableAPIKey() {
    const response = await this.api.get("/iterable-api-key");
    return response.data;
  }

  async getIterableList() {
    const response = await this.api.get("/iterable-lists");
    return response.data;
  }

  async getIterableListSize(list_id) {
    const response = await this.api.get(
      `/iterable-lists/size?list_id=${list_id}`
    );
    return response.data;
  }

  async getklaviyoListSize(list_id) {
    const response = await this.api.get(
      `/klaviyo-lists/size?list_id=${list_id}`
    );
    return response.data;
  }

  async iterableImport(payload) {
    const response = await this.api.post("/iterable-import", payload);
    return response.data;
  }

  async iterableAPIKeyDelete() {
    const response = await this.api.delete("/iterable-api-key");
    return response.status;
  }

  async iterableExport(payload) {
    const response = await this.api.post("/iterable-export", payload);
    return response.data;
  }

  async iterableExportDetails(payload) {
    const response = await this.api.get(`/iterable-export?job_id=${payload}`);
    return response.data;
  }

  async fetchPaymentMethods() {
    const response = await this.api.get("/accounts/payment-methods");
    return response.data;
  }

  async deletePaymentMethod(id) {
    const response = await this.api.delete(`/accounts/payment-methods/${id}`);
    return response.data;
  }

  async patchPaymentMethod(id, payload) {
    const response = await this.api.patch(
      `/accounts/payment-methods/${id}`,
      payload
    );
    return response.data;
  }

  async verifyCreditPack(payload) {
    const response = await this.api.post("/credit-packs/verify", payload);
    return response.data;
  }

  async createPayment(payload) {
    const response = await this.api.post("/credit-packs", payload);
    return response.data;
  }

  async confirmPayment(payload, creditpackId) {
    const response = await this.api.patch(
      `/credit-packs/${creditpackId}`,
      payload
    );
    return response.data;
  }

  async createCreditPack(payload) {
    const response = await this.api.post("/credit-packs", payload);
    return response.data;
  }

  async fetchCreditPacks() {
    const response = await this.api.get("/credit-packs");
    return response.data;
  }

  async fetchTransactions(urlParams = {}) {
    let url = "/transactions";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async updateBillingAddress(payload) {
    let url = "/transactions/billing-address";
    const response = await this.api.post(url, payload);
    return response.data;
  }

  async getBillingAddress() {
    let url = "/transactions/get-billing-address";
    const response = await this.api.get(url);
    return response.data;
  }

  async deleteTax(urlParams) {
    const response = await this.api.delete(
      `/transactions/delete-tax?tax_id=${urlParams}`
    );
    return response.data;
  }

  async getPricing(urlParams = {}) {
    let url = "/credit-packs/pricing-table";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async changePassword(payload) {
    const response = await this.api.post("/accounts/change-password", payload);
    return response.data;
  }

  async resetSubUserPassword(payload) {
    const response = await this.api.post(
      "/accounts/reset-subuser-password",
      payload
    );
    return response.data;
  }

  async changeEmail(payload) {
    const response = await this.api.post(
      "/accounts/change-email/initiate",
      payload
    );
    return response.data;
  }

  async confirmChangeEmail(payload) {
    const response = await this.api.post(
      "/accounts/change-email/verify",
      payload
    );
    return response.data;
  }

  async getSetting(id, urlParams = {}) {
    let url = `/admin/settings/${id}`;
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async changeSetting(payload) {
    const response = await this.api.post("/admin/settings", payload);
    return response.data;
  }

  async deleteSetting(key, userId) {
    return this.api.delete(`/admin/settings/${key}?user=${userId}`);
  }

  async usageSummary(payload) {
    const response = await this.api.post("/admin/usage-summary", payload);
    return response.data;
  }

  async fetchPublicSettings() {
    const response = await this.api.get(`/admin/settings/public`);
    return response.data;
  }

  async getJobPreview(id, urlParams) {
    let url = `/jobs/${id}/preview`;
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async fetchDiscountCodes(urlParams) {
    let url = "/admin/discount-codes";
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}?${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async createDiscountCode(payload) {
    const response = await this.api.post("/admin/discount-codes", payload);
    return response.data;
  }

  async changeDiscountCode(id, payload) {
    const response = await this.api.put(`/admin/discount-codes/${id}`, payload);
    return response.data;
  }

  async adminVerifyUser(user) {
    const response = await this.api.post(`admin/user-verify`, {
      user_id: user.id,
    });
    return response.data;
  }

  async adminUserBlockActions(payload) {
    const response = await this.api.post(`admin/user-action`, payload);
    return response.data;
  }

  async adminTransferParent(user) {
    const response = await this.api.post(`admin/transfer-parent`, {
      user_id: user.id,
    });
    return response.data;
  }

  async adminEraseUserData(payload) {
    const response = await this.api.post("admin/user-deletion", payload);
    return response.data;
  }

  async adminGetUserErasures(userId) {
    const response = await this.api.get(
      `admin/user-deletion?${new URLSearchParams({ user_id: userId })}`
    );
    return response.data;
  }

  async adminRetryUserErasure(requestId) {
    const response = await this.api.post(
      `admin/user-deletion/${requestId}/retry`
    );
    return response.data;
  }

  async deleteDiscountCode(id, payload) {
    const response = await this.api.delete(
      `/admin/discount-codes/${id}`,
      payload
    );
    return response.data;
  }

  async checkDiscountCode(discountCode) {
    const response = await this.api.post("/credit-packs/check-discount-code", {
      discount_code: discountCode,
    });
    return response.data;
  }

  async fetchWebhooks() {
    const response = await this.api.get("/accounts/webhooks");
    return response.data;
  }

  async createWebhook(payload) {
    const response = await this.api.post("/accounts/webhooks", payload);
    return response.data;
  }

  async deleteWebhook(id) {
    const response = await this.api.delete(`/accounts/webhooks/${id}`);
    return response.data;
  }

  async fetchApiKeys() {
    const response = await this.api.get("/accounts/api-keys");
    return response.data;
  }

  async createApiKey(payload) {
    const response = await this.api.post("/accounts/api-keys", payload);
    return response.data;
  }

  async changeApiKey(id, payload) {
    const response = await this.api.patch(`/accounts/api-keys/${id}`, payload);
    return response.data;
  }

  async deleteApiKey(id) {
    const response = await this.api.delete(`/accounts/api-keys/${id}`);
    return response.data;
  }

  async sendMessage(payload) {
    const response = await this.api.post(`/contact`, payload);
    return response.data;
  }

  async getKlaviyoList(searchText, cursor) {
    let url = "/klaviyo-lists";
    const params = new URLSearchParams();
    if (searchText) {
      params.set("search", searchText);
    }
    if (cursor) {
      params.set("cursor", cursor);
    }
    if ([...params].length) {
      url = `${url}?${params.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async getKlaviyoListMembers(payload) {
    const response = await this.api.get(`/klaviyo-lists/${payload.id}`, {
      params: {
        cursor: payload.cursor,
      },
    });
    return response.data;
  }

  async getGRListMembers(payload) {
    let url = `/getresponse-lists/${payload.id}`;
    if (payload.current_page) {
      url = url + `?page=${payload.current_page}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async getGRList(searchText, pageNumber) {
    let url = "/getresponse-lists";
    if (searchText && pageNumber) {
      url += `?search=${searchText}&page=${pageNumber}`;
    } else if (searchText) {
      url += `?search=${searchText}`;
    } else if (pageNumber) {
      url += `?page=${pageNumber}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async generateUserSpecificReport(payload) {
    const response = await this.api.post(`billing-reports`, payload);
    return response.data;
  }

  async getUserSpecificReports(userId, urlParams) {
    let url = `billing-reports?user_id=${userId}`;
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}&${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async getGenericReports(urlParams) {
    let url = `billing-reports?type=generic`;
    if (urlParams) {
      const searchParams = new URLSearchParams(urlParams);
      url = `${url}&${searchParams.toString()}`;
    }
    const response = await this.api.get(url);
    return response;
  }

  async downloadBillingReport(path) {
    return await this.api.post(
      "/billing-report-download",
      { path },
      { responseType: "blob" }
    );
  }

  async getSystemStatusUser() {
    const response = await this.api.get("/status");
    return response.data;
  }

  async postNgpVanAPIKey(payload) {
    return await this.api.post("/ngpvan-api-key", payload);
  }

  async getNgpVanList(next) {
    let url = "/ngpvan-lists";
    if (next) {
      const encodedNext = encodeURIComponent(next);
      url = url + `?next=${encodedNext}`;
    }
    const response = await this.api.get(url);
    return response.data;
  }

  async ngpVanImport(payload) {
    const response = await this.api.post("/ngpvan-import", payload);
    return response.data;
  }

  async ngpVanAPIKeyDelete() {
    const response = await this.api.delete("/ngpvan-api-key");
    return response.status;
  }

  async ngpVanExport(payload) {
    const response = await this.api.post("/ngpvan-export", payload);
    return response.data;
  }
}

export default AlfredService;
